export default __webpack_public_path__ + "static/Inter-Regular-c8ba52b05a9ef10f47584d08ece2ec5c.woff2";